<template>
	<v-form ref="form" v-model="formIsValid" lazy-validation>
		<modal
			:exibir="exibir"
			:titulo="titulo"
			:max-width="450"
			:is-confirmar-visivel="true"
			:custom-actions="false"
			:acao-confirmar="confirmar"
			nome-botao-confirmar="Confirmar"
			:acao-cancelar="fecharModal"
			:is-confirmar-desabilitado="!formIsValid"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="mt-3" dense>
					<v-col cols="12">
						<label-personalizado class="pb-0" nome-campo="Documento"></label-personalizado>
						<texto-tooltip :tamanho-maximo="tamanhoMaximo" :texto="tituloDocumento"></texto-tooltip>
					</v-col>
					<v-col cols="12">
						<label-personalizado
							nome-campo="Motivo Cancelamento"
							class="pt-5 ma-0"
							:obrigatorioPorPadrao="true"
						></label-personalizado>
						<v-textarea
							v-model="motivoCancelamento"
							:rules="regrasTituloDocumentoModelo"
							placeholder="Informe o motivo do cancelamento"
							type="string"
							clearable
							counter="300"
							hide-details="auto"
							rows="2"
							class="ma-0 py-0"
						></v-textarea>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import TextoTooltip from '@/views/components/TextoTooltip'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'formulario-motivo-cancelamento',
	components: {
		TextoTooltip,
		LabelPersonalizado,
	},
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		idDocumento: {
			type: Number,
			required: true,
		},
		titulo: {
			type: String,
			default: '',
		},
		tituloDocumento: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			motivoCancelamento: '',
			formIsValid: false,
			tamanhoMaximo: 30,
			regrasTituloDocumentoModelo: [
				(value) => this.regraObrigatoriedade(value, 'Campo obrigatório.'),
				(value) =>
					this.regraDeTamanhoMaximoString(
						value,
						300,
						'O campo de título deve ser igual ou menor do que 300 caracteres!',
					),
			],
		}
	},
	methods: {
		async confirmar() {
			if (this.$refs.form.validate()) {
				const payload = {
					idDocumento: this.idDocumento,
					motivo: this.motivoCancelamento,
				}
				await this.$emit('confirmar', payload)
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
